<template>
  <div
    v-if="rewardData"
    class="base-reward align-items-center"
    :class="[
      displayInline ? 'd-inline-flex' : 'd-flex flex-column',
      isKingspass ? 'kingspass-reward' : 'normal-reward',
      `base-${rewardType}`,
    ]"
  >
    <div
      class="reward-icon bg-img"
      :class="`${rewardType}-reward`"
      :style="{ 'background-image': 'url(' + assetUrl + ')' }"
    ></div>
    <div class="reward-amount d-inline-flex">
      <div class="amount-number">
        {{ formattedRewardAmount }}
      </div>
      <div v-if="rewardSuffix" class="amount-suffix">
        {{ rewardSuffix }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseReward",
  props: {
    displayInline: {
      type: Boolean,
      default: false,
    },
    shortenGoldAmount: {
      type: Boolean,
      default: false,
    },
    rewardData: {
      type: Object,
      required: true,
    },
    customReward: {
      type: Boolean,
      default: false,
    },
    isKingspass: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rewardType() {
      if (this.customReward) {
        return this.normalizeRewardType(this.rewardData.type);
      }

      return this.normalizeRewardTypeFromAsset(this.rewardData.asset);
    },
    rewardSuffix() {
      if (this.rewardType === "gold") {
        return "";
      } else if (this.rewardType === "expbooster") {
        return "m";
      } else {
        return "x";
      }
    },
    formattedRewardAmount() {
      if (this.customReward) {
        return this.rewardData.amount;
      }
      let amount = this.rewardData.amount;
      if (this.rewardType === "gold") {
        if (this.shortenGoldAmount) {
          return this.formatNumber(amount, true);
        } else {
          return this.formatNumber(amount);
        }
      } else if (this.rewardType === "expbooster") {
        return amount / 60;
      } else {
        return amount;
      }
    },
    assetUrl() {
      if (this.customReward) {
        return this.rewardData.src;
      }

      const asset = this.rewardData.asset || {};
      const urlData = asset.image_urls;

      if (typeof urlData === "string") {
        return urlData;
      }

      if (urlData && urlData.image_url) {
        return urlData.image_url;
      }

      return this.fallbackAssetUrl(this.rewardType);
    },
  },
  methods: {
    normalizeRewardTypeFromAsset(asset = {}) {
      const payload = asset.payload || {};
      return this.normalizeRewardType(
        payload.type || asset.wallet || asset.title || asset.type
      );
    },
    normalizeRewardType(type) {
      const normalized = type ? String(type).toLowerCase() : "";

      if (normalized.endsWith("card") || normalized === "cards") {
        return "card";
      }
      if (normalized === "crowns") {
        return "crown";
      }
      if (normalized === "loyaltypoint" || normalized === "loyaltypoints") {
        return "loyalty";
      }
      if (normalized === "booster" || normalized === "exp_booster") {
        return "expbooster";
      }

      return normalized || "gold";
    },
    fallbackAssetUrl(type) {
      const fallbackMap = {
        gold: this.$whitelabel.currencies.primary.single,
        crown: this.$whitelabel.currencies.secondary.single,
        elixir: this.$whitelabel.currencies.tertiary.single,
        loyalty: this.$whitelabel.assets.features.loyalty.accent,
        card: this.$whitelabel.assets.features.cards.accent,
        expbooster: this.$whitelabel.assets.features.booster.icon,
      };

      return fallbackMap[type] || this.$whitelabel.currencies.primary.single;
    },
  },
};
</script>
<style lang="scss">
.base-reward {
  .reward-icon {
    width: 48px;
    height: 48px;
  }
  .reward-amount {
    font-family: kanit-semibold;
    font-size: 20px;
    text-shadow: 3px 3px 0 black, 2px 2px 0 black;
    .amount-number,
    .amount-suffix {
      font-family: inherit;
      text-transform: none;
    }
  }
}
</style>
